<template>
  <page-layout class="market">

    <div class="title">
      <div class="title_top">
        <p>Infographic</p>
      </div>
    </div>

    <article class="inner">

      <div class="list_insta" id="feed_results">
        <ul>
          <template v-for="(feed, index) in getFeeds">
            <li :key="`feed-${feed.idx}`" class="ctnr" @click="goArticle(feed)"><img :src="getFileExist(feed.feed_img)" class="fit_img"/>
            </li>
            <p v-if="(index+1)%5===0 && !isMobile" class="ad_list">
              <display-container :section="911">
                <a slot-scope="{ component, row }">
                  <img :src="component.getImage(row)">
                </a>
              </display-container>
            </p>
            <p v-if="(index+1)%6===0 && isMobile" class="ad_list">
              <display-container :section="911">
                <a slot-scope="{ component, row }">
                  <img :src="component.getImage(row)">
                </a>
              </display-container>
            </p>
          </template>
        </ul>
      </div>

    </article>


    <!-- PC Modal -->
    <q-dialog ref="modal" :no-route-dismiss="true" @hide="removeQueryIdx">
      <div class="insta_pop">
        <a class="close_btn" @click="$refs.modal.hide()"></a>
        <!-- prev/next button -->
        <div class="arrows">
          <p class="next" @click="goArticle(selectedFeed.prev_feed)" v-if="selectedFeed.prev_feed"></p>
          <p class="prev" @click="goArticle(selectedFeed.next_feed)" v-if="selectedFeed.next_feed"></p>
        </div>
        <div class="insta_ctnr">
          <div class="img">
            <transition name="el-fade-in-linear">
              <img :src="getFileExist(selectedFeed.feed_img)" v-if="isModalInnerBox">
            </transition>
          </div>
          <div class="article">
            <div class="logo">
              <span><img src="/statics/img/bi_origin.png"></span>
              <p>bluffandcatch</p>
            </div>
            <transition name="el-fade-in-linear">
              <div v-if="isModalInnerBox">
                <p class="subj">{{ selectedFeed.title }}</p>
                <p class="con" v-html="selectedFeed.contents"></p>
                <p class="tag" v-if="selectedFeed.tags">
                  <i>TAGs</i>
                  <router-link :to="`/article/tag/${tag}`" v-for="(tag, i) in selectedFeed.tags" :key="i">{{tag}}</router-link>
                </p>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </q-dialog>


  </page-layout>
</template>

<script>
	import Vue from 'vue'
  import { QDialog, Loading } from 'quasar'
  import SubPageLayout from '../layouts/SubPageLayout'
  import DisplayContainer from '../components/DisplayContainer'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import PageLayout from '../layouts/PageLayout'
  import { mapGetters } from 'vuex'
  export default {
    name: "Market",
    components: {
      SubPageLayout,
      PageLayout,
      DisplayContainer,
      QDialog,
      Loading,
    },
    metaInfo () {
      return {
        title: `${this.getAppName} | Infographic`,
        titleTemplate: '%s',
        meta: [
          {vmid: 'description', name: 'description', content: `Poker Market infographics`},
          {vmid: 'image', name: 'image', content: '/statics/seo/seo_main.jpg'},
          {vmid: 'og:title', property: 'og:title', content: `Infographic | ${this.getAppName}`},
          {vmid: 'og:description', property: 'og:description', content: `Poker Market infographics`},
          {vmid: 'og:image', property: 'og:image', content: '/statics/seo/seo_main.jpg'}
        ]
      }
    },
    data () {
      return {
        isOpenDialog: false,
        isModalInnerBox: true,
        selectedFeed: {},
      }
    },
    activated () {
      this.$store.dispatch('callFeeds')
      if (this.getRouteQueryIdx) {
        if (this.isMobile) {
          this.$router.replace(`/market/article/${this.getRouteQueryIdx}`)
        } else {
          this.showModalAfterGetData(this.getRouteQueryIdx)
        }
      }
    },
    deactivated() {
      this.$refs.modal.hide()
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getFeeds',
      ]),
      getAccess () {
        return 'pc'
      },
      isMobile () {
        return this.getAccess === 'mobile'
      },
      getRouteQueryIdx () {
        return this.$route.query.idx
      }
    },
		methods: {
      ...CommonMethods,
      goArticle (row) {
        if (this.getAccess === 'pc') {
          const fromIdx = this.getRouteQueryIdx
          this.$router.replace({query: {idx: row.idx}}).then(() => {
            if (fromIdx !== row.idx) {
              this.selectedFeed = this.cloneData(row)
              this.showModalAfterGetData(row.idx)
            } else {
              this.showModal()
            }
          })
        }
        else {
          this.$router.push(`/market/article/${row.idx}`)
        }
      },
      showModalAfterGetData (idx) {
        // Loading.show()
        this.isModalInnerBox = false
        this.$axios.get('/feeds/' + idx).then(rs => {
          this.selectedFeed = this.cloneData(rs.data)
          this.showModal()
          setTimeout(() => {
            // Loading.hide()
            this.isModalInnerBox = true
          }, 200)
        })
      },
      showModal () {
        this.$refs.modal.show()
      },
      removeQueryIdx () {
        this.$router.replace({query: {}})
        this.selectedFeed = {}

      }
    }
  }
</script>

<style scoped>
  .market {
    position: relative;
    top: -40px;
  }
  .market .title {
    background: url(/statics/img/bg_sub_title.jpg) center no-repeat;
    background-size: cover;
    margin-bottom: 40px;
  }
  .title_top {
    position: relative;
    width: 1220px;
    height: 180px;
    display: flex;
    align-items: center;
    margin: 0 auto;
  }
  .title_top:before {
    content: "";
    display: inline-block;
    width: 54px;
    height: 54px;
    background: url(/statics/img/bi_white.png) center no-repeat;
    background-size: cover;
    margin-right: 15px;
  }
  .title_top p {
    font-family: 'Roboto Slab';
    font-size: 60px;
    font-weight: 900;
    color: #fff;
    line-height: 1.0em;
    text-transform: capitalize;
    z-index: 1;
  }
/*
  .list_insta ul {
    display: inline-block;
    margin: 0 30px 30px 0;
    width: calc((100% - 60px) / 3);
    height: 386px;
  }
  .list_insta li {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .list_insta ul:nth-child(3n) {
    margin-right: 0;
  }
  .list_insta ul:nth-child(6n) {
    margin-bottom: 180px;
  }
  .list_insta ul .ad_list {
    position: absolute;
    left: 50%;
    margin-top: -90px;
    transform: translate(-50%, -50%);
  }
*/
  .list_insta ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(295px, 1fr));
    grid-gap: 10px;
    grid-auto-flow: dense;
  }
  .list_insta ul li.ctnr {
    min-height: 300px;
  }
  .list_insta ul li:nth-of-type(10n+1),
  .list_insta ul li:nth-of-type(10n+8) {
    grid-column-end: span 2;
    grid-row-end: span 2;
    min-height: 610px;
  }
  .list_insta .ad_list {
    grid-column: 1 / -1;
  }
  .list_insta .ad_list:not(:has(a)) {
    display: none;
  }
  .list_insta .ad_list .display-container {
    height: 200px !important;
  }
  .list_insta .ad_list /deep/ a {
    padding: 20px 0;
  }
  .list_insta .ad_list /deep/ a img {
    width: 728px !important;
    height: 90px !important;
  }
/*
  .list_insta ul {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    grid-gap: 5px;
    grid-auto-rows: minmax(240px, auto);
    grid-auto-flow: dense;
    padding: 0;
  }
  .list_insta li {
    position: relative;
    cursor: pointer;
  }
  .list_insta li:nth-child(5n+1),
  .list_insta li:nth-child(7n+1) {
    grid-column-end: span 2;
    grid-row-end: span 2;
  }
*/
  .list_insta li {
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background: #00270e;
    border-radius: 8px;
    overflow: hidden;
  }
  .list_insta li img.fit_img {
    width: 100%;
    transition: .15s;
    object-fit: contain;
  }
  .list_insta li:hover img {
    filter: brightness(120%);
  }
  .insta_pop {
    max-width: 85vw;
    height: auto;
    max-height: 90vh;
    overflow: hidden;
    border-radius: 8px;
  }
  .insta_pop .close_btn {
		position: absolute;
		top: 15px;
		right: 15px;
		/*background: rgba(0,0,0,0.6);
		border-radius: 100%;*/
		cursor: pointer;
		width: 40px;
		height: 40px;
		z-index: 1;
	}
	.insta_pop .close_btn:before {
		content: "×";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-48%, -54%);
		font-size: 40px;
		font-weight: 300;
		color: #00ff64;
	}
	.insta_pop .close_btn:hover:before {
		color: #fff;
	}
  .insta_pop .insta_ctnr {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: row;
  }
  .insta_pop .insta_ctnr .img {
    width: 90vh;
    height: 90vh;
    display: flex;
    align-items: center;
    background: #000;
    position: relative;
    overflow: hidden;
  }
  .insta_pop .insta_ctnr .img img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .insta_pop .insta_ctnr .article {
    position: relative;
    width: 48vh;
    max-width: 450px;
    height: 90vh;
    padding: 25px;
    word-break: normal;
    overflow-y: auto;
  }
  .insta_pop .insta_ctnr .article .logo {
    padding: 0 0 20px 0;
    border-bottom: 1px solid #ddd;
  }
  .insta_pop .insta_ctnr .article .logo span {
    display: inline-block;
    width: 40px;
    height: 40px;
    background: #000;
    padding: 5px 6px;
    border-radius: 100%;
  }
  .insta_pop .insta_ctnr .article .logo span img {
    width: 100%;
  }
  .insta_pop .insta_ctnr .article .logo p {
    display: inline-block;
    font-size: 1.2em;
    font-weight: 900;
    line-height: 40px;
    margin-left: 10px;
  }
  .insta_pop .insta_ctnr .article .subj {
    font-size: 1.75em;
    font-weight: 900;
    letter-spacing: -0.02em;
    padding: 20px 0;
  }
  .insta_pop .insta_ctnr .article .con {
    font-size: 1.15em;
    font-weight: 400;
    padding-bottom: 40px;
    line-height: 1.4em;
  }
  .insta_pop .insta_ctnr .article .con /deep/ a {
    color: #379339;
    text-decoration: underline;
  }
  .insta_pop .insta_ctnr .article .tag {
    /*position: absolute;
    bottom: 5%;
    width: calc(100% - 50px);*/
  }
  .insta_pop .insta_ctnr .article .tag i {
    display: block;
    font-size: 1.15em;
    font-weight: 700;
    padding-bottom: 10px;
  }
  .insta_pop .insta_ctnr .article .tag a {
    display: inline-block;
    margin-right: 10px;
    line-height: 1.6em;
    font-size: 1.10em;
    font-weight: 400;
    color: #379339;
  }
  .insta_pop .insta_ctnr .article .tag a:before {
    content: "#";
  }
  .insta_pop .insta_ctnr .article .tag a:hover {
    color: #000;
  }
  .insta_pop .arrows {
    position: absolute;
    top: 50%;
    left: 50%;
    display: block;
    width: 96vw;
    height: 50px;
    transform: translate(-50%, -50%);
  }
  .insta_pop .arrows p {
    display: inline-block;
    width: 50px;
    height: 50px;
    background: rgba(0,0,0,0.5);
    border-radius: 100%;
    position: relative;
    cursor: pointer;
  }
  .insta_pop .arrows p:before {
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border: #fff solid;
    border-width: 2px 2px 0 0;
    position: absolute;
    top: 50%;
    left: 44%;
    transform: translate(-50%, -50%) rotate(45deg);
  }
  .insta_pop .arrows p.prev:before {
    border-width: 0 0 2px 2px;
    left: 56%;
  }
  .insta_pop .arrows p.next {
    float: right;
  }
  .insta_pop .arrows p:hover {
    background: rgba(0,0,0,0.8);
  }
  /deep/ .fr-video { display: block !important; position: relative !important; height: 0 !important; padding-bottom: 56.25% !important; }
  /deep/ .fr-video iframe { position: absolute !important; width: 100% !important; height: 100% !important; top:0; left: 0; }
  /deep/ [data-f-id="pbf"] {
    display: none;
  }
</style>
